import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onClose: '&',
        user: '=',
        siteId: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.onClose()"></button>
            <h2>{{ 'manage.Privileges' | translate }}</h2>
        </div>
        <div class="modal-body">
            <ul class="privileges01">
                <li ng-repeat="privilege in vm.privileges">
                    <p><span>{{ vm.rolePrivilegeLabels[privilege] }}</span></p>
                </li>
                <li ng-repeat="privilege in vm.companyPrivileges">
                    <p><span>{{ vm.companyPrivilegeLabels[privilege] }}</span></p>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor (lodash, UserAssignmentResource, TokenService,
                 ROLE_PRIVILEGE_ENUM, ROLE_COMPANY_PRIVILEGE_ENUM, ROLE_COMPANY_MODULE_PRIVILEGE_ENUM,
                 ROLE_PRIVILEGE_EMPLOYEE_ENUM, ROLE_PRIVILEGE_DIRECT_MANAGER_ENUM) {
        this.lodash = lodash;
        this.UserAssignmentResource = UserAssignmentResource;
        this.TokenService = TokenService;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
        this.ROLE_COMPANY_PRIVILEGE_ENUM = ROLE_COMPANY_PRIVILEGE_ENUM;
        this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM = ROLE_COMPANY_MODULE_PRIVILEGE_ENUM;
        this.ROLE_PRIVILEGE_EMPLOYEE_ENUM = ROLE_PRIVILEGE_EMPLOYEE_ENUM;
        this.ROLE_PRIVILEGE_DIRECT_MANAGER_ENUM = ROLE_PRIVILEGE_DIRECT_MANAGER_ENUM;
    }

    $onInit () {
        this.rolePrivilegeLabels = this.lodash.assign({},
            this.ROLE_PRIVILEGE_ENUM.LABELS,
            this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.LABELS,
            this.ROLE_PRIVILEGE_EMPLOYEE_ENUM.LABELS,
            this.ROLE_PRIVILEGE_DIRECT_MANAGER_ENUM.LABELS
        );

        // Do not show modules privileges in modal COUR-2900
        this.companyPrivilegeLabels = this.ROLE_COMPANY_PRIVILEGE_ENUM.LABELS;
        this.privileges = [];
        this.companyPrivileges = [];
        // get site specific privileges
        this.UserAssignmentResource.query({
            siteId: this.siteId,
            userId: this.user.id,
            expand: 'role'
        }).$promise.then((assignments) => {
            assignments.forEach((assignment) => {
                // assignment privileges
                assignment.privilegesJson.forEach((privilege) => {
                    // exclude MY_EMPLOYEE_MANAGE privilege
                    if (this.privileges.indexOf(privilege) === -1
                        && privilege !== this.ROLE_PRIVILEGE_ENUM.KEYS.MY_EMPLOYEE_MANAGE) {
                        this.privileges.push(privilege);
                    }
                });
                // role related privileges
                assignment.role.privilegesJson.forEach((privilege) => {
                    if (this.privileges.indexOf(privilege) === -1) {
                        this.privileges.push(privilege);
                    }
                });
            });
        });
        // get company privileges
        this.UserAssignmentResource.query({
            onlyCompanyPrivileges: true,
            userId: this.user.id
        }).$promise.then((assignments) => {
            assignments.forEach((assignment) => {
                assignment.privilegesJson.forEach((privilege) => {
                    if (this.companyPrivileges.indexOf(privilege) === -1) {
                        this.companyPrivileges.push(privilege);
                    }
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/manage/privilege/index.js